module.exports = __webpack_public_path__ + "img/ctagrid4.7a224774.png";